import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

import activityAndMovementHeroGradients from '../_data/activityAndMovementHeroGradients';

const ActivityAndMovementHero = (): JSX.Element => {
  return (
    <section data-cy="activity-and-movement-hero">
      <LandingPageHero
        backgroundProps={{
          color: 'cream-100',
          gradients: activityAndMovementHeroGradients,
        }}
        copy="activity_hero_copy"
        eyebrow="activity_hero_eyebrow"
        images={[
          {
            localizedAlt: 'soccer_alt',
            src: '/activity/soccer-ball',
          },
          {
            localizedAlt: 'skate_boarding_alt',
            src: '/activity/skate-boarding',
          },
        ]}
        textColor="text-brown-600"
        title="activity_hero_title"
      />
    </section>
  );
};

export default ActivityAndMovementHero;
